import React from 'react';
import Heading from '@vfuk/core-heading';
import Spacing from '@vfuk/core-spacing';
import {
  CollapsibleContainer,
  CollapsibleContainerBody,
  CollapsibleContainerHeader
} from '@vfuk/core-collapsible-container';
import SimpleGrid from '@vfuk/core-simple-grid';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import options from '../../../../helpers/ContentFulOptions';
import Block from '@vfuk/core-block';
import Accordion from '@vfuk/core-accordion';
import useAccordion from '@vfuk/core-accordion/dist/hooks/useAccordion';
import {
  accordionContainer,
  BlockWrapper,
  spring,
  springNested
} from './styles/SectionAccordion.styles';
import { SectionAccordionProps } from './types/SectionAccordion.types';

const SectionAccordion = ({ section }: SectionAccordionProps) => {
  const { name, content } = section;
  const { openIds, onToggle } = useAccordion({
    multi: true
  });

  function fireUtagEvent(title) {
    if (window.utag && window.utag.link && typeof window.utag.link === "function") {
      const utagData = {
        event_name: 'ui_interaction',
        event_action: 'Click Component',
        event_category: 'Go & Grow Online',
        event_label: 'FAQs',
        component_name: title,
        component_type: 'Button'
      };
      window.utag.link(utagData);
    }
  }

  return (
    <div css={accordionContainer}>
      <BlockWrapper>
        <Block className="section">
          <div css={spring}>
            <div css={springNested}>
              <SimpleGrid
                columns={{
                  sm: 1
                }}
              >
                <div data-testid="accordion-header">
                  <Spacing spacingLevel={{ top: 4, bottom: 4 }}>
                    <Heading text={name} level={3} justify="center" />
                  </Spacing>
                </div>
              </SimpleGrid>
            </div>
            <div css={springNested}>
              <SimpleGrid
                columns={{
                  sm: 1
                }}
              >
                <Accordion
                  appearance="primary"
                  openIds={openIds}
                  onToggle={onToggle}
                >
                  {content?.map(item => {
                    const { id, heading, accordionContent } = item;
                    const accordionText = documentToReactComponents(
                      JSON.parse(accordionContent.raw),
                      options
                    );
                    return (
                      <CollapsibleContainer key={id} id={id}>
                        <div
                          className="accordion-collapsible-container-test-class"
                          aria-expanded={openIds.includes(id)}
                        >
                          {openIds.includes(id) && fireUtagEvent(heading)}
                          <CollapsibleContainerHeader>
                            {heading}
                          </CollapsibleContainerHeader>
                          <CollapsibleContainerBody>
                            {accordionText}
                          </CollapsibleContainerBody>
                        </div>
                      </CollapsibleContainer>
                    );
                  })}
                </Accordion>
              </SimpleGrid>
            </div>
          </div>
        </Block>
      </BlockWrapper>
    </div>
  );
};

export default SectionAccordion;
